import { useTranslation } from "react-i18next";
import { useLaunchApp } from "../hooks/useLaunchApp";
import { CheckIcon, PlayIcon, Spinner } from "./icons";

interface Props {
  onLaunch: () => Promise<void>;
}

export default function LaunchButton({ onLaunch }: Props) {
  const { t } = useTranslation();
  const { status, launch } = useLaunchApp(onLaunch);

  return (
    <button
      onClick={launch}
      disabled={status === "launching"}
      title={
        status === "launched"
          ? t("deviceInstaller.launchSuccess")
          : status === "error"
          ? t("deviceInstaller.retryLaunch")
          : t("deviceInstaller.launchOnDevice")
      }
      className={`flex items-center justify-center w-8 h-8 rounded-md transition-colors ${
        status === "launched"
          ? "bg-green-50 text-green-500"
          : status === "error"
          ? "bg-red-50 text-red-400 hover:bg-red-100"
          : "bg-gray-50 text-gray-500 hover:bg-gray-100 hover:text-green-600 border border-gray-200"
      }`}
    >
      {status === "launching" ? (
        <Spinner className="w-3.5 h-3.5" color="green" />
      ) : status === "launched" ? (
        <CheckIcon className="w-3.5 h-3.5" />
      ) : (
        <PlayIcon className="w-3.5 h-3.5" />
      )}
    </button>
  );
}
